import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list-move",
  "use": "icon-list-move-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-list-move\"><defs><style type=\"text/css\"></style></defs><path d=\"M806.4 310.144 217.6 310.144c-1.408 0-2.56 1.152-2.56 2.56l0 55.296c0 1.408 1.152 2.56 2.56 2.56l588.8 0c1.408 0 2.56-1.152 2.56-2.56l0-55.296C808.96 311.296 807.808 310.144 806.4 310.144z\" p-id=\"6412\" /><path d=\"M806.4 484.864 217.6 484.864c-1.408 0-2.56 1.152-2.56 2.56L215.04 542.72c0 1.408 1.152 2.56 2.56 2.56l588.8 0c1.408 0 2.56-1.152 2.56-2.56l0-55.296C808.96 486.016 807.808 484.864 806.4 484.864z\" p-id=\"6413\" /><path d=\"M806.4 659.712 217.6 659.712c-1.408 0-2.56 1.152-2.56 2.56l0 55.296c0 1.408 1.152 2.56 2.56 2.56l588.8 0c1.408 0 2.56-1.152 2.56-2.56l0-55.296C808.96 660.864 807.808 659.712 806.4 659.712z\" p-id=\"6414\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list-move.svg
// module id = 58Hk
// module chunks = 101